export default function Canvas_Transformations() {
  return (
    <div>
      <h1>Canvas_Transformations Component</h1>
    </div>
  );
}
